<template>
	<div id="area_right3">
		<div class="cc-header">访客进出分析
			<div class="view_btn" @click="showTable">访客明细</div>
		</div>
		<div class="main-value" id="visit_inout"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
	data() {
		return {};
	},
	mounted() {
		this.initData();
		// 定时器刷新，10分钟
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 10);
	},
	methods: {
		showTable() {
			this.$emit("showBigEven", "访客明细", "visitInfo");
		},
		initData() {
			// 基于准备好的dom，初始化echarts实例
			let visitRecordChart = echarts.init(
				document.getElementById("visit_inout")
			);
			this.$http.get("/dataView/platform/getVisitorRecord?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					var option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'cross',
								label: {
									backgroundColor: '#6a7985'
								}
							}
						},
						grid: {
							x: 46,
							top: "10%",
							bottom: "25%",
						},
						xAxis: [{
							type: 'category',
							boundaryGap: false,
							data: result.xData,
							axisLabel: {
								textStyle: {
									color: '#34deff',
									fontSize: fontSize(0.12)
								}
							}
						}],
						yAxis: [{
							type: 'value',
							splitLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: 'rgba(255, 255, 255, 0.2)',
								}
							},
							axisLabel: {
								textStyle: {
									color: '#34deff',
									fontSize: fontSize(0.12)
								}
							},
							axisLine: {
								show: true
							}
						}],
						series: [{
							name: '访客人数',
							type: 'line',
							smooth: true,
							areaStyle: {
								color: '#7058e8'
							},
							emphasis: {
								focus: 'series'
							},
							data: result.ydatas
						}
						]
					};
					visitRecordChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => visitRecordChart.resize(), false);
				}
			});
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	destroyed() {
		window.onresize = null;
	}
};
function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#area_right3 {
	height: 100%;

	.cc-header {
		width: 100%;
		text-align: center;
		background: url("../../assets/img/cam_titbgsmall02.png") center no-repeat;
		background-size: 100%;
		color: #34deff;
		font-size: 0.2rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.6rem;
	}

	.main-value {
		height: 80%;
	}

	.view_btn {
		position: absolute;
		right: 0.3rem;
		top: 0.6rem;
		display: inline-block;
		cursor: pointer;
		width: 1rem;
		height: 0.35rem;
		line-height: 0.35rem;
		border-radius: 0.2rem;
		background-image: linear-gradient(135deg, #15517c, #323f86);
		color: #35fff9;
		font-size: 0.15rem;
		z-index: 1;
	}
}
</style>
